export default __webpack_public_path__ + "static/media/Tyler_Strong_Resume_2021.408c5feb.pdf";